import { adminStore } from 'state'
import {
  createOutputPermission,
  fetchOutputPermissions,
  removeOutputPermission
} from 'api/administration/output'

export const getOutputPermissions = async () => {
  const { body } = await fetchOutputPermissions()

  adminStore.update((prevState) => ({
    ...prevState,
    output: body
  }))
}

export const addOutputPermission = async (body) => {
  const { role, pages } = body

  const permissions = pages.map(({ page, selected }) => ({
    roleName: role,
    outputField: page,
    read: selected,
    create: false,
    delete: false,
    update: false,
    import_: false,
    export: false
  }))

  const payload = {
    roleName: role,
    scenarioType: '',
    permissions
  }
  await createOutputPermission(payload)
  await getOutputPermissions()
}

export const deleteOutputPermission = async ({ roleName }) => {
  await removeOutputPermission(roleName)
  await getOutputPermissions()
}
